import underscore from 'vendor/underscore';

export default underscore;
